import { render } from "./NavigationLeft.vue?vue&type=template&id=3b465b45"
import script from "./NavigationLeft.vue?vue&type=script&lang=js"
export * from "./NavigationLeft.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/pub/www/mtech/releases/20231005081654Z/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__